import React from "react";
import { useValidateCoderRole } from "../hooks/use-validate-coder-role";
import * as notify from "shared/notify";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExternalLinkAlt } from "@fortawesome/free-solid-svg-icons";

export const ValidateCoderLink = ({ taskType, taskKey, taskLink }) => {
    const { mutate: validateCoder } = useValidateCoderRole();

    const checkCoderRole = () => {
        if (taskType.split(".")[0] === "coding") {
            validateCoder(
                { taskKey },
                {
                    onSuccess: (data) => {
                        if (!data) {
                            return notify.error(
                                "Access Denied: You are either currently working on/have already completed this UPC, or you do not have permissions to open this task."
                            );
                        }

                        window.open(taskLink, "_blank", "noopener", "noreferrer");
                    },
                }
            );
        } else {
            window.open(taskLink, "_blank", "noopener", "noreferrer");
        }
    };

    return (
        <button className="link" onClick={checkCoderRole}>
            <FontAwesomeIcon icon={faExternalLinkAlt} />
        </button>
    );
};
